import React from 'react';
import './styles.css';
import { Button, Image } from '@tw/tw-component-library';
import LogoImage from '../../assets/Logo-Taylor Wessing_whitespace.png?url'
import { styled } from 'styled-components';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { AccountInfo } from '@azure/msal-browser';

interface PageLayoutProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  activeAccount: AccountInfo | null;
  login: () => void;
  logout: () => void;
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  color: white;
  background-color: #141b4d;
  border-bottom: 1px solid #e0e0e0;
`;

const LoginContainer = styled.div`
  text-align: right;
  width: 100%;
`;

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  activeAccount,
  login,
  logout,
}) => {
  return (
    <div>
      <header>
        <HeaderContainer>
          {/* Need to fix height and width in component library */}
          <Image
            src={LogoImage}
            alt="Taylor Wessing Logo"
            width={100}
            height={50}
            style={{
              width: '200px',
            }}
          />
          <AuthenticatedTemplate>
            <LoginContainer>
              <p>
                Welcome,{' '}
                {activeAccount?.name
                  ? activeAccount.name.split(', ').reverse().join(' ')
                  : 'User'}
              </p>
              <Button variant="block" onClick={logout}>
                Logout
              </Button>
            </LoginContainer>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Button variant="block" onClick={login}>
              Login
            </Button>
          </UnauthenticatedTemplate>
        </HeaderContainer>
      </header>
      <main className="page-layout__content">{children}</main>
    </div>
  );
};
